module.exports = __webpack_public_path__ + "static/media/org_entity.2c26a553.svg";